import styled from 'styled-components';

import { colors, px } from '../../../../contrib/ui';

export const WarningMessage = styled.div`
  color: ${colors.orange};
  font-size: ${px(16)};
  padding: ${px(16)};
`;
